import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const goTo = (
    path: string,
    options?: {
      patientId?: string;
      state?: Record<string, unknown>;
      replace?: boolean;
    }
  ) => {
    const finalPath = options?.patientId ? path.replace(':patientId', options.patientId) : path;
    if (options?.state || options?.replace) {
      navigate(finalPath, { state: options.state, replace: options.replace });
    } else {
      navigate(finalPath);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const goToAddPatient = () => {
    navigate('/dashboard/patients/add');
  };

  const goToTreatmentPlan = () => {
    navigate('/dashboard/treatment-plan');
  };

  const goToTreatmentPlanCreation = () => {
    navigate('/dashboard/treatment-plan/create');
  };

  return {
    goTo,
    goBack,
    goToAddPatient,
    goToTreatmentPlan,
    goToTreatmentPlanCreation,
    currentPath: location.pathname,
    params,
    state: location.state as Record<string, unknown> | null,
  };
};
